export default __webpack_public_path__ + "static/media/Ballroll_00345.fc3af1c6.png";